var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { onBeforeUnmount, onMounted, ref, watch } from 'vue';
import RecruitFilter from './RecruitFilter.vue';
import ApiService from '@/ts/core/services/ApiService';
export default /*@__PURE__*/ _defineComponent(__assign({
    name: 'two_depth_filters',
}, { __name: 'RecruitFilters', props: {
        title: {
            required: true,
            type: String
        },
        filterType: {
            required: true,
            type: String
        },
        filterVisible: {
            type: Boolean,
            required: true
        },
        initValue: {
            required: false,
            type: (Array),
            default: function () { return []; },
        },
    }, emits: ['toggle', 'update:init-value'], setup: function (__props, _a) {
        var _this = this;
        var __emit = _a.emit;
        var props = __props;
        var emits = __emit;
        var locales = ref({});
        var resumeFilters = ref({
            resume_skill: [],
        });
        var options = ref([]);
        var selected = ref(Array.isArray(props.initValue) ? props.initValue.slice() : props.initValue);
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('filters mounted -> initValue:', props.initValue);
                        return [4 /*yield*/, loadLocale()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, loadCodes()];
                    case 2:
                        _a.sent();
                        document.addEventListener('click', handleClickOutside);
                        return [2 /*return*/];
                }
            });
        }); });
        watch(function () { return props.initValue; }, function (newVal) {
            if (Array.isArray(newVal) && newVal.length > 0) {
                selected.value = newVal.slice();
                console.log('watch filters initValue:', selected.value);
            }
        }, { immediate: true });
        onBeforeUnmount(function () {
            document.removeEventListener('click', handleClickOutside);
        });
        var loadLocale = function () { return __awaiter(_this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ApiService.get(process.env.MIX_API_HOST + '/trans/service')];
                    case 1:
                        data = (_a.sent()).data;
                        if (data) {
                            locales.value = data.data;
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        var loadCodes = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, ApiService.get(process.env.MIX_API_HOST + '/service-code/v2/' + props.filterType)
                        .then(function (response) {
                        options.value = response.data.data;
                    })
                        .catch(function (error) {
                        console.error('Error loading codes:', error);
                    })];
            });
        }); };
        var getResumeFilterCategories = function (type) {
            return resumeFilters.value["resume_".concat(type)] || [];
        };
        var handleFilterToggle = function (filterType, isVisible) {
            emits('toggle', filterType);
        };
        var filterContainerRef = ref(null);
        var handleClickOutside = function (event) {
            var container = filterContainerRef.value;
            if (!container)
                return;
            if (!props.filterVisible)
                return;
            if (!container.contains(event.target)) {
                emits('toggle', props.filterType);
            }
        };
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", {
                class: "interest_filter d-flex flex-column w-100",
                ref_key: "filterContainerRef",
                ref: filterContainerRef
            }, [
                _createVNode(RecruitFilter, {
                    title: __props.title,
                    ref: "".concat(__props.filterType, "Ref"),
                    type: __props.filterType,
                    locales: locales.value,
                    options: options.value,
                    initValue: __props.initValue,
                    "request-categories": getResumeFilterCategories(__props.filterType),
                    "filter-visible": __props.filterVisible,
                    "onUpdate:initValue": _cache[0] || (_cache[0] = function (val) { return emits('update:init-value', val); }),
                    onFilterToggleEvent: handleFilterToggle
                }, null, 8, ["title", "type", "locales", "options", "initValue", "request-categories", "filter-visible"])
            ], 512));
        };
    } }));
